class CardProductGallery extends HTMLElement {
  constructor() {
    super();
    this._bound = false;
  }

  connectedCallback() {
    if (this._bound) return;
    this._bound = true;

    const track = this.querySelector('[data-gallery-track]');
    if (!track) { this._bound = false; return; }

    const slides = Array.from(track.querySelectorAll(':scope > .card-gallery__slide'));
    const slidesCount = parseInt(this.dataset.slidesCount, 10) || slides.length;

    if (slides.length < 2) { this._bound = false; return; }

    this._track = track;
    this._slides = slides;
    this._slidesCount = slidesCount;

    this._btnPrev = this.querySelector('[data-gallery-prev]');
    this._btnNext = this.querySelector('[data-gallery-next]');

    this._onScroll = this.handleScroll.bind(this);
    this._onClickPrev = (e) => { e.preventDefault(); e.stopPropagation(); this.step(-1); };
    this._onClickNext = (e) => { e.preventDefault(); e.stopPropagation(); this.step(1); };

    this._track.addEventListener('scroll', this._onScroll, { passive: true });
    if (this._btnPrev) this._btnPrev.addEventListener('click', this._onClickPrev);
    if (this._btnNext) this._btnNext.addEventListener('click', this._onClickNext);

    this._resizeObserver = new ResizeObserver(() => this.syncState());
    this._resizeObserver.observe(this._track);

    this.syncState();
  }

  disconnectedCallback() {
    if (!this._bound) return;
    this._bound = false;

    if (this._track) this._track.removeEventListener('scroll', this._onScroll);
    if (this._btnPrev) this._btnPrev.removeEventListener('click', this._onClickPrev);
    if (this._btnNext) this._btnNext.removeEventListener('click', this._onClickNext);

    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }

    this._track = null;
    this._slides = null;
    this._btnPrev = null;
    this._btnNext = null;
    this._onScroll = null;
    this._onClickPrev = null;
    this._onClickNext = null;
  }

  handleScroll() {
    this.syncState();
  }

  step(direction) {
    const slideWidth = this.getSlideWidth();
    const next = Math.max(0, Math.min(this._slidesCount - 1, this.getCurrentIndex() + direction));
    this._track.scrollTo({ left: next * slideWidth, behavior: 'smooth' });
  }

  syncState() {
    const idx = this.getCurrentIndex();

    this.style.setProperty('--slider-index', String(idx));
    this.style.setProperty('--slides-count', String(this._slidesCount));

    if (this._btnPrev) {
      const atStart = idx <= 0;
      this._btnPrev.disabled = atStart;
      this._btnPrev.setAttribute('aria-disabled', String(atStart));
    }

    if (this._btnNext) {
      const atEnd = idx >= this._slidesCount - 1;
      this._btnNext.disabled = atEnd;
      this._btnNext.setAttribute('aria-disabled', String(atEnd));
    }
  }

  getCurrentIndex() {
    const slideWidth = this.getSlideWidth();
    if (!slideWidth) return 0;
    const raw = this._track.scrollLeft / slideWidth;
    return Math.max(0, Math.min(this._slidesCount - 1, Math.round(raw)));
  }

  getSlideWidth() {
    if (this._slides.length > 1) {
      return this._slides[1].offsetLeft - this._slides[0].offsetLeft;
    }
    return this._track.clientWidth;
  }
}

if (!customElements.get('card-product-gallery')) {
  customElements.define('card-product-gallery', CardProductGallery);
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.target && typeof customElements.upgrade === 'function') {
    customElements.upgrade(event.target);
  }
});
